<script>export let active = false;
const enter = () => {
  active = true;
};
const leave = () => {
  active = false;
};
</script>

<div class="twist-group" on:mouseenter={enter} on:mouseleave={leave} on:focusin={enter} on:focusout={leave}>
  <slot {active} />
</div>

<style>
  div {
    display: contents;
  }
</style>
